import { render, staticRenderFns } from "./MapBox.vue?vue&type=template&id=970751b2"
import script from "./MapBox.vue?vue&type=script&lang=js"
export * from "./MapBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports